// AudienceToggle — WHO THE APP IS SHOWN AS: User view or Customer view (D9,
// PROJECTS_AND_TEMPLATES.md, Alex 2026-10-14).
//
// Alex: "Concerning Customer. Can it be a toggle button instead. Like Customer view,
// user view in the main heading beside 'Working in' drop down." It sits in the top
// bar, next to WorkingInSelect, because it is the same kind of choice: not a screen
// but a way of looking at every screen.
//
//   User view      the internal app: Catalog, Products, Functions, Proposal, 3D Model.
//   Customer view  the project as its customer sees it: the function tree and the
//                  Proposal, nothing with cost. Where placements are tested for
//                  how they will look.
//
// A project-only view: on Standard there is no customer, so the Customer half is
// `disabled` with the reason in its title.
//
// ⚠ COLOUR-BLIND: the active half is BOLD and outlined, not just tinted, and the
// disabled half says why in words (title) on top of being faded.
import Text from './Text.jsx';
import { BTN_PRIMARY_OUTLINE, BTN_SECONDARY, BTN_DISABLED } from '../theme-tokens.js';

// The shared button roles (check:style, 2026-10-12): the chosen half is the navy outline,
// the other the plain secondary; a disabled half takes the disabled overlay.
const PAD = { padding: '2px 10px' };

export default function AudienceToggle({ customer, onChange, customerDisabledReason = null }) {
  const disabled = !!customerDisabledReason;
  return (
    <span
      role="group"
      aria-label="View as"
      style={{ display: 'inline-flex', gap: 2 }}
    >
      <button
        type="button"
        aria-pressed={!customer}
        onClick={() => customer && onChange(false)}
        title="The internal app: Catalog, Products, Functions, Proposal, 3D Model."
        style={{ ...(customer ? BTN_SECONDARY : BTN_PRIMARY_OUTLINE), ...PAD }}
      ><Text kind="small" bold={!customer}>User view</Text></button>
      <button
        type="button"
        aria-pressed={customer}
        disabled={disabled}
        onClick={() => !customer && !disabled && onChange(true)}
        title={customerDisabledReason || 'The project as its customer sees it: the function tree and the Proposal, no cost.'}
        style={{ ...(customer ? BTN_PRIMARY_OUTLINE : BTN_SECONDARY), ...(disabled ? { ...BTN_DISABLED, cursor: 'not-allowed' } : null), ...PAD }}
      ><Text kind="small" bold={customer}>Customer view</Text></button>
    </span>
  );
}
